import { useMutation } from '@tanstack/react-query';
import { BaseResponseType, apiClient } from 'shared/api';
import { SKIP_SERVER_ERROR_TOAST } from 'shared/lib/notifyServerError';

const postLogout = async (): Promise<BaseResponseType<string>> => {
  const { data } = await apiClient.post('/auth/logout');
  return data;
};

export const usePostLogout = ({ onSuccess, onError }: { onSuccess: () => void; onError: () => void }) => {
  return useMutation({
    mutationFn: postLogout,

    // 서버 호출이 실패해도 호출부가 로컬 세션을 지우고 홈으로 보내 로그아웃을 완료시킨다.
    // 사용자에겐 성공한 동작이므로 전역 서버 에러 토스트는 띄우지 않는다.
    meta: { [SKIP_SERVER_ERROR_TOAST]: true },

    onSuccess: () => {
      onSuccess();
    },
    onError: () => {
      onError();
    },
  });
};
